import { WalletGatedButton, TokenInput } from "@/components";
import { useRedeemForm } from "@/hooks";
import { TOKEN_IDS } from "@/types";
import { DialogAwareButtonContainer, DialogAwareContentContainer } from "@/components";
interface RedeemFormProps {
    isLoading?: boolean;
    initialAmount?: number;
    isDialog?: boolean;
}

export function RedeemForm({ isLoading, initialAmount, isDialog }: RedeemFormProps) {
    const {
        redeemAmount,
        redeemAmountError,
        selectedTokenId,
        submitRedeem,
        selectTokenId,
        setMaxAmount,
        isAmountOverBalance,
    } = useRedeemForm({
        initialAmount,
    });

    const handleSubmit = submitRedeem;
    const handleTokenSelect = selectTokenId;
    const handleMaxClick = setMaxAmount;

    return (
        <form onSubmit={handleSubmit} className="w-[480px] max-w-full">
            <DialogAwareContentContainer isDialog={isDialog} className="space-y-4">
                <TokenInput
                    amount={redeemAmount}
                    amountError={redeemAmountError}
                    selectedTokenId={selectedTokenId}
                    handleTokenSelect={handleTokenSelect}
                    handleMaxClick={handleMaxClick}
                    tokenOptions={[TOKEN_IDS.IUSD]}
                    label="Enter amount to redeem"
                />
            </DialogAwareContentContainer>

            <DialogAwareButtonContainer isDialog={isDialog}>
                <WalletGatedButton
                    className="py-2.5 text-lg"
                    type="submit"
                    isLoading={isLoading}
                    disabled={isAmountOverBalance}
                    fullWidth
                    variant="primary"
                    color="primary"
                >
                    Redeem
                </WalletGatedButton>
            </DialogAwareButtonContainer>
        </form>
    );
}
